import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { unMaskCurrency } from '@utils/masks/unMaskCurrency'

export const adjustTotalPeopleModalSchema = yupResolver(
  yup.object({
    launch: yup.string().required('Lançamento é obrigatório'),
    date: yup.string().required('Data é obrigatória'),
    totalValue: yup
      .string()
      .required('Valor total é obrigatório')
      .test('valid-currency', 'Informe um valor total válido', (value) => {
        if (value == null || String(value).trim() === '') return false
        const num = unMaskCurrency(value)
        return !Number.isNaN(num)
      }),
    observations: yup.string().required('Observações é obrigatória')
  })
)
